/**
 * App-wide DatePicker with consistent input format (yyyy/MM/dd).
 * Use this instead of MUI DatePicker directly to ensure format consistency.
 * Must be used inside a LocalizationProvider (e.g. with AdapterDateFns).
 */
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';

/** Default date input format used across the app (e.g. 2026/02/18) */
export const DATE_INPUT_FORMAT = 'yyyy/MM/dd';

export function AppDatePicker<TInputDate, TDate>(
  props: DatePickerProps<TInputDate, TDate>
) {
  const { format, ...rest } = props;
  return (
    <DatePicker
      format={format ?? DATE_INPUT_FORMAT}
      {...rest}
    />
  );
}
